<template>
  <ul class="form-item-list">
    <li>
      <h3>계약자 정보를 입력해주세요</h3>
      <h5 style="color: #787878">피보험자와 계약자가 다르면 관계를 입력하십시오.​​</h5>
    </li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="본인"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
      <el-checkbox
        class="round"
        label="다름"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
    </li>
    <li v-if="yes">
      <div class="detail-form">
        <el-row>
          <element-textbox
            v-model="detail['계약자명'].value"
            :error="detail['계약자명'].error"
            :label="detail['계약자명'].label"
            :placeholder="detail['계약자명'].placeholder"
            @input="changeDetail('계약자명')"
          />
        </el-row>

        <el-row>
          <element-textbox
            class="split"
            ref="dob"
            v-model="detail['계약자주민번호앞자리'].value"
            :error="detail['계약자주민번호앞자리'].error"
            :label="detail['계약자주민번호앞자리'].label"
            :placeholder="detail['계약자주민번호앞자리'].placeholder"
            @input="inputSocialNumber('dob')"
          />

          <element-textbox
            class="split"
            ref="pin"
            v-model="detail['계약자주민번호뒷자리'].value"
            :error="detail['계약자주민번호뒷자리'].error"
            :label="detail['계약자주민번호뒷자리'].label"
            :placeholder="detail['계약자주민번호뒷자리'].placeholder"
            @input="inputSocialNumber('pin')"
          />
        </el-row>

        <el-row>
          <element-textbox
            v-model="detail['계약자전화번호'].value"
            :error="detail['계약자전화번호'].error"
            :label="detail['계약자전화번호'].label"
            :placeholder="detail['계약자전화번호'].placeholder"
            @input="inputPhoneNumber"
          />
        </el-row>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Contrator',
  props: ['formData'],
  data() {
    return {
      yes: this.formData.answer.value === '다름',
      no: this.formData.answer.value === '본인',
      detail: {
        계약자명: {
          label: "계약자명",
          placeholder: '예: 홍길동',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
        계약자주민번호앞자리: {
          label: "계약자 주민번호(앞자리)",
          placeholder: '예: 900101',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
        계약자주민번호뒷자리: {
          label: "뒷자리",
          placeholder: '예: 1234567',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        },
        계약자전화번호: {
          label: "계약자 전화번호",
          placeholder: '예: 010-1234-5678',
          value: "",
          error: "",
          validations: [
            { type: "required", message: "필수항목입니다" }
          ],
        }
      }
    }
  },
  mounted() {
    this.$emit('update', { type: '계약자명', value: '' });
    this.$emit('update', { type: '계약자주민번호', value: '' });
    this.$emit('update', { type: '계약자전화번호', value: '' });
  },
  methods: {
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      const key = type === 'yes' ? '다름' : '본인';
      this.$data[reverse] = !event;
      this.$emit('update', { type: '관계', value: key });
    },
    changeDetail(key) {
      this.$emit('update', { type: key, value: this.detail[key].value });
    },
    changeSocialNumber() {
      if (this.detail.계약자주민번호앞자리.value !== '' && this.detail.계약자주민번호뒷자리.value !== '') {
        this.detail.계약자주민번호앞자리.error = '';
        this.detail.계약자주민번호뒷자리.error = '';

        if (this.detail.계약자주민번호앞자리.value.length < 6) {
          this.detail.계약자주민번호앞자리.error = '주민번호 앞자리는 6자리입니다.';
          return;
        }
        
        if (this.detail.계약자주민번호뒷자리.value.length < 7) {
          this.detail.계약자주민번호뒷자리.error = '주민번호 뒷자리는 7자리입니다.';
          return;
        }

        this.$emit('update', { type: '계약자주민번호', value: this.detail.계약자주민번호앞자리.value + this.detail.계약자주민번호뒷자리.value });
      } else {
        this.detail.계약자주민번호앞자리.error = '주민번호 형식에 맞지 않습니다.';
      }
    },
    inputSocialNumber(ref) {
      const LIMIT = {
        dob: 6,
        pin: 7
      }[ref];
      const key = {
        dob: '계약자주민번호앞자리',
        pin: '계약자주민번호뒷자리',
      }[ref];

      const value = this.detail[key].value;
      let num = value;

      if (value.length > LIMIT) {
        num = value.substr(0, LIMIT);
      } else {
        num = value.replace(/\D/g, '');
      }

      this.detail[key].value = num;
      this.changeSocialNumber();
    },
    inputPhoneNumber(value) {
      let phoneNumber = value;

      if (value.length > 13) {
        phoneNumber = phoneNumber.substr(0, 13);
      } else {
        phoneNumber = value.replace(/[^0-9]/g, '').replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, '$1-$2-$3').replace("--", "-");
      }

      this.detail.계약자전화번호.value = phoneNumber;
      this.changeDetail('계약자전화번호')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
  .detail-form {
    h3 {
      margin-bottom: 2*$unit;
    }
    .el-row {
      margin-bottom: 2*$unit;

      &.my-1 {
        margin-bottom: $unit;
      }
      .mx-0 {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: $unit;
      }
      .el-input {
        height: 54px;

        & ::-webkit-input-placeholder { text-align:right; }
        & input:-moz-placeholder { text-align:right; }
  
        .el-input__inner {
          height: 54px;
          border-radius: 0;
        }
  
        .el-input__suffix-inner {
          line-height: 54px;
          color: #000;
        }
      }
    }
  }
}
</style>